import React, { useState } from "react";
import { motion } from "framer-motion";
import { MdDownload } from "react-icons/md";

const DownloadResume = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleDownload = () => {
    setIsDownloading(true);
    setProgress(0); // Reset progress

    // Simulate download progress
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          // Trigger file download after progress is complete
          triggerDownload();
          return 100; // Ensure progress is capped at 100
        }
        return prev + 10; // Increment progress
      });
    }, 200); // Adjust this interval as needed
  };

  const triggerDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Navneet_UNIYAL.pdf`;
    link.download = "Navneet_Uniyal_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Reset downloading state after a delay
    setTimeout(() => {
      setIsDownloading(false);
    }, 500); // Delay to allow for download to initiate
  };

  return (
    <div className="border-b border-neutral-900 pb-20">
      <h1 className="my-10 text-center text-4xl">
        <button
          className={`btn btn-primary pointer-events-none ${
            isDownloading ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={isDownloading}
        >
          {isDownloading ? "Downloading..." : `Download `}
          {!isDownloading && <span className="text-neutral-500">Resume</span>}
        </button>
      </h1>
      <div className="flex flex-col items-center mt-4">
        {isDownloading && (
          <div className="relative w-64 h-4 bg-gray-200 rounded-full overflow-hidden">
            <motion.div
              className="absolute h-full bg-green-500 rounded-full"
              initial={{ width: 0 }}
              animate={{
                width: `${progress}%`,
                transition: { duration: 0.2, ease: "easeInOut" },
              }}
            />
          </div>
        )}
        <motion.div
          animate={{
            y: isDownloading ? 0 : [0, -10, 0], // Animate up and down when not downloading
          }}
          transition={{
            duration: 0.5,
            ease: "easeInOut",
            repeat: isDownloading ? 0 : Infinity, // Stop animation if downloading
          }}
        >
          <MdDownload
            className={`${
              isDownloading ? "pointer-events-none" : "cursor-pointer"
            } text-9xl mt-4 `}
            onClick={handleDownload}
            disabled={isDownloading}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default DownloadResume;
